<template>
  <div>
    <ContentHeader />

    <div class="content-container">
      <div class="condition-line">
        <SearchRow @handleFilter="handleFilter">
          <!-- 这个button颜色可能不对需要调整 -->
          <div class="feature-btn upload-btn cursor" @click="toFreezerList">
            <i class="iconfont iconzu151"/>浏览资产管理
          </div>
          <!-- 这个button颜色可能不对需要调整 -->
          <div class="feature-btn order-btn cursor" @click="uploadApplyDetail">
            <i class="iconfont iconzu111" />上传领用明细
          </div>
        </SearchRow>
      </div>

      <el-table :data="freezerList" class="while-data-table" v-loading="listLoading">
        <el-table-column label="图片">
          <template slot-scope="scope">
            <div class="item-image">
              <img :src="getImageUrl(scope.row.pocmDTO)">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="编码">
          <template slot-scope="scope">
            {{ scope.row.itemCode }}
          </template>
        </el-table-column>
        <el-table-column label="名称" label-class-name="cell-left">
          <template slot-scope="scope">
            <div class="item-name">{{ scope.row.itemName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="品牌">
          <template slot-scope="scope">
            {{ scope.row.pocmDTO.itemBrandList[0].abiBrandName }}
          </template>
        </el-table-column>
        <el-table-column label="分配额度">
          <template slot-scope="scope">
            {{ scope.row.quotaDetailDTO.totalQuota }}
          </template>
        </el-table-column>
        <el-table-column label="剩余额度">
          <template slot-scope="scope">
            {{ scope.row.quotaDetailDTO.availableQuota }}
          </template>
        </el-table-column>
        <el-table-column label="有效时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.quotaDTO.effectiveDate | parseTime('{y}-{m}-{d}') }} - {{ scope.row.quotaDTO.expireDate | parseTime('{y}-{m}-{d}') }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div><el-button type="text" size="small" @click="viewFreezer(scope.row)">查看详情</el-button></div>
            <div><el-button class="btn-red-plain" size="small" @click="applyFreezer(scope.row)">立即领用</el-button></div>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="while-data-table-footer">
        <el-col>
          <el-pagination
            background
            :current-page="queryParam.page"
            :page-size="queryParam.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"/>
        </el-col>
      </el-row>

      <!-- 上传订单明细 -->
      <FreezerImport ref="freezer-import"/>

    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import ContentHeader from '../../components/content-header'
import SearchRow from './components/search-row'
import freezerApi from '@/api/freezer'
import FreezerImport from './components/freezer-import'
export default {
  name: 'freezer-apply',
  components: {
    ContentHeader,
    SearchRow,
    FreezerImport
  },
  data () {
    return {
      queryParam: {
        page: 1,
        pageSize: 10,
        abiBrandId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        isCampaign: 0
      },
      total: null,
      freezerList: [],
      listLoading: false
    }
  },
  created () {
    this.queryFreezerList()
  },
  methods: {
    toFreezerList () {
      this.$router.push('/freezer/list')
    },
    uploadApplyDetail () {
      this.$refs['freezer-import'].show()
    },

    // 冰柜列表
    queryFreezerList () {
      this.listLoading = true
      freezerApi.queryFreezerList(this.queryParam).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.freezerList = res.data.resultData.quotaItemList
          this.total = res.data.resultData.pageInfo.totalCounts
        }
      }).catch(() => {
        this.listLoading = false
      })
    },

    // 立即领用
    applyFreezer (row) {
      this.$router.push({
        path: '/freezer/fill-order',
        query: {
          detailId: row.quotaDetailDTO.detailId,
          itemId: row.itemId
        }
      })
    },

    // 查看详情
    viewFreezer (row) {
      this.$router.push({
        path: '/freezer/detail',
        query: {
          freezerId: row.itemId,
          detailId: row.quotaDetailDTO.detailId,
          itemCode: row.itemCode,
          from: 'apply',
          effectiveDate: row.quotaDTO.effectiveDate,
          expireDate: row.quotaDTO.expireDate
        }
      })
    },

    // 搜索
    handleFilter (value) {
      this.queryParam.abiBrandId = value.abiBrandId
      this.queryParam.keyword = value.keyword
      this.queryParam.minPrice = value.minPrice
      this.queryParam.maxPrice = value.maxPrice
      this.queryFreezerList()
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryFreezerList()
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
